import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

import { sustituirInspector, eliminarInspectorDeZona } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'

import { useDispatch, useSelector } from 'react-redux'
import estilos from './CuadroInspectorComponent.module.css'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CredencialComponent from './CredencialComponent'
import { hostSocket } from '../../../configuraciones'
import { darDeBajaInspector } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'

import { getZonas } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import ConfiguracionFirmaComponent from '../Configuracion/FirmaInspector/ConfiguracionFirmaComponent'

function CuadroInspectorComponent(props) {

    const dispatch = useDispatch()
    const { id, imagenpath, nombre, apellidos } = props.inspector
    const zonas = useSelector(store => store.Zonas.zonas)
    const inspectores = useSelector(store => store.Inspectores.inspectores)

    const handleRemoveInspector = (id) => {

        const fecha = new Date();

        const data = {
            data: {
                idinspector: id,
                isactivo: false,
                fechabaja: fecha
            }
        }

        dispatch(darDeBajaInspector(data)).then((response) => {
            props.actualizarInspectores()
        })

        //dispatch(deleteInspector(parseInt(id))).then((response) => {
        //    dispatch(getInspectores())
        //})
        handleCloseEliminarInspector();
    }

    const handlePromoverInspector = (id) => {
        //dispatch(promoverInspector(id))
    }

    const [initialStateFormik, setInitialStateFormik] = React.useState({
        zona: ''
    })
    const [urlImg, setUrlImage] = React.useState("")

    const data = [
        {
            name: 'Enero',
            pv: 2400,
            amt: 2400,
        },
        {
            name: 'Marzo',
            pv: 1398,
            amt: 2210,
        },
        {
            name: 'Abril',
            pv: 9800,
            amt: 2290,
        },
        {
            name: 'Mayo',
            pv: 3908,
            amt: 2000,
        },
        {
            name: 'Junio',
            pv: 4800,
            amt: 2181,
        },
        {
            name: 'Julio',
            pv: 3800,
            amt: 2500,
        },
        {
            name: 'Agosto',
            pv: 4300,
            amt: 2100,
        },
    ];

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const styleBox = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const styleBoxFirma = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        height: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };


    const [openReasignarVisita, setOpenReasignarVisita] = React.useState(false);
    const handleOpenReasignarVisita = () => setOpenReasignarVisita(true);
    const handleCloseReasignarVisita = () => setOpenReasignarVisita(false);

    const [openEliminarInspector, setOpenEliminarInspector] = React.useState(false);
    const handleOpenEliminarInspector = () => setOpenEliminarInspector(true);
    const handleCloseEliminarInspector = () => setOpenEliminarInspector(false);

    const [openEstadisticas, setOpenEstadisticas] = React.useState(false);
    const handleOpenEstadisticas = () => setOpenEstadisticas(true);
    const handleCloseEstadisticas = () => setOpenEstadisticas(false);

    const [openCredencial, setOpenCredencial] = React.useState(false);
    const handleOpenCredencial = () => setOpenCredencial(true);
    const handleCloseCredencial = () => setOpenCredencial(false);

    const [openFirma, setOpenFirma] = React.useState(false);
    const handleOpenFirma = () => setOpenFirma(true);
    const handleCloseFirma = () => setOpenFirma(false);

    const getInfoZona = (idInspector) => {
        let zona = ''
        if (props.inspector.zonasinspector.length > 0) {
            props.inspector.zonasinspector.forEach(z => {
                zona = zona + ', ' + z.zona.nombrezona;
            })
        } else {
            zona = 'Pendiente de asignación';
        }
        return zona;
    }

    const handleReasignarInspector = (idZona) => {
        const zonaAReasignar = zonas.find(zona => idZona == zona.id)
        const zonaAnterior = zonas.find(zona => props.inspector.id === zona.inspector)
        //if (zonaAnterior) {
        //    dispatch(eliminarInspectorDeZona(zonaAnterior))
        //}
        //dispatch(sustituirInspector({ zona: zonaAReasignar, inspector: props.inspector }))
       //console.log(props.inspector.idinspector)
        let data = {
            data: {
                idinspector: props.inspector.idinspector,
                idzona: Number(idZona)
            }
        }

        props.actualizarInspectores()
        handleCloseReasignarVisita()
    }

    const modificarInspector = () => {
        props.actualizarInspectores()
        props.onModify(props.inspector)
    }

    React.useEffect(() => {
        urlImg
    }, [urlImg])

    React.useEffect(() => {
        dispatch(getZonas())
        let urlImg = hostSocket + "/";
        let array = props.inspector.imagenpath.split("/")

        let pos;
        if (array.length > 0) {

            for (let index = 0; index < array.length; index++) {
                if (array[index] === "docs") {
                    pos = index;
                }

            }

            for (let i = pos; i < array.length; i++) {
                if (i == array.length - 1) {
                    urlImg += array[i]
                } else {
                    urlImg += array[i] + "/"
                }
            }
            setUrlImage(urlImg)
        }

        // if (array.length > 4) {
        //     urlImg += array[4] + "/" + array[5] + "/" + array[6] + "/" + array[7] + "/" + array[8]
        //     console.log(urlImg)
        //     setUrlImage(urlImg)
        // }
    }, [])

    React.useEffect(() => {
        props.inspector
    }, [props.inspector])

    const modalEliminarInspector = (inspector) => {
        return (
            <Modal
                open={openEliminarInspector}
                onClose={handleCloseEliminarInspector}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBox}>
                    <div className='text-center'>
                        ¿Desea realmente dar de Baja a este Inspector?<br /><br />
                        <strong>{props.inspector.nombre} {props.inspector.apellidos} </strong> <br /><br />
                        <button className='btn btn-danger' onClick={() => handleRemoveInspector(props.inspector.idinspector)}> Dar de Baja</button>
                    </div>
                </Box>
            </Modal>
        )
    }

    const modalSubirFirma = (inspector) => {
        return (
            <Modal
                open={openFirma}
                onClose={handleCloseFirma}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleBoxFirma}>
                    <div className='row text-center' style={{ backgroundColor: 'white' }}>
                        <ConfiguracionFirmaComponent idinspector={props.inspector.idinspector} cerrar={handleCloseFirma}></ConfiguracionFirmaComponent>
                    </div>
                </Box>
            </Modal>
        )
    }


    return (
        <Fragment>
            <div className={`col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 text-center`} >
                <div className={`${props.inspector.idcatalogopuestos === 0 ? estilos.cuadroCapacitacion : estilos.cuadro}`} >
                    {props.inspector.estatus === 'En capacitación' ? <h4 >En capacitación</h4> : <></>}
                    <img srcSet={urlImg} className={`img-fluid ${estilos.imagenInspector}`}
                    ></img>
                    <br /><br />

                    <div>

                        <div className={`${estilos.nombreInspector} text-center`}>

                            <h5>{nombre} {apellidos}</h5>
                            {props.inspector.estatus === 'En capacitación' ? <h5>Acreditación: {props.inspector.acreditacion}</h5> : <></>}
                        </div>
                        <hr></hr>
                        <div className={`${estilos.nombreInspector} text-center`} style={{ fontSize: '11px' }}>
                            {/* <strong>Zona asignada: </strong> <br /><br />{getInfoZona(props.inspector.id)} */}

                        </div>

                        <div>

                        </div>

                        <hr></hr>
                        <table className={`${estilos.textoInformativo}`}>
                            <thead></thead>
                            {
                                //<tbody>
                                //    <tr>
                                //        <td>Visitas realizadas:</td>
                                //        <td>234</td>
                                //    </tr>
                                //    <tr>
                                //        <td>Promedio de visitas/semana:</td>
                                //        <td>10</td>
                                //    </tr>
                                //    <tr>
                                //        <td>Desempeño:</td>
                                //        <td><button className='badge btn-success'>Alto</button></td>
                                //    </tr>
                                //</tbody>
                            }
                        </table>
                    </div>
                    {
                        //<hr></hr>
                    }
                    <h5>Opciones:</h5>
                    <div className={`${estilos.botonera} text-center`}>
                        <button onClick={() => modificarInspector()} className='badge btn-warning col-4'>Modificar </button>
                        {
                            props.inspector.isactivo ? (
                                <button onClick={handleOpenEliminarInspector} className='badge btn-danger col-4'>Eliminar </button>
                            ) :
                                (null)
                        }

                    </div><br />
                    <div className={`${estilos.botonera} text-center`}>
                        <button onClick={() => handleOpenFirma()} className='badge btn-success col-6'>Modificar Firma</button>
                    </div><br />
                    {/* () => handleRemoveInspector(props.inspector.idinspector)* */}
                    <div className={`${estilos.botonera} text-center`}>
                        {/* <button onClick={handleOpenReasignarVisita} className='badge btn-primary'>Reasignar Zona </button> */}
                        {
                            //<button onClick={handleOpenEstadisticas} className='badge btn-success'>Ver estadísticas</button>
                        }
                        {props.inspector.estatus === 'En capacitación' ?
                            <button onClick={() => props.onPromover(props.inspector)} className='badge btn-secondary'>Promover a Inspector</button> : <></>}
                    </div>
                    <br /><br />
                </div>
            </div>
            <Modal
                open={openReasignarVisita}
                onClose={handleCloseReasignarVisita}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2">
                        Reasignar Zona
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }} variant="h5" >
                        ¿Que Zona deseas reasignar a: <strong>{nombre} {apellidos}</strong> ?
                        <br></br><br></br>
                    </Typography>

                    <Formik
                        initialValues={initialStateFormik}
                        validate={values => {
                            const errors = {};
                            if (values.zona === "") {
                                errors.zona = 'Seleccione una zona'
                            }
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            handleReasignarInspector(values.zona)
                            setSubmitting(false);
                        }}

                    >
                        {({ isSubmitting, errors }) => (
                            <Form>
                                <div className={`container ${estilos.contenedorForm}`}>

                                    <div className='row'>
                                        <div className='col-md-4'>

                                        </div>
                                        <div className='col-md-4'>
                                            <label htmlFor="zona">Zona:</label><br />
                                            <Field as="select" name="zona" className='form-control'>
                                                {
                                                    <option key={0} value={0}>Seleccione una zona </option>
                                                }
                                                {
                                                    zonas.map((zona, index) => (
                                                        <option key={index} value={zona.idzona}>{zona.nombrezona} </option>
                                                    ))

                                                }
                                            </Field>
                                            <ErrorMessage name="zona" component="div" className={`${estilos.error}`} /><br />
                                        </div>

                                        <div className='col-md-4'>

                                        </div>

                                    </div>
                                    <br></br><br></br>
                                    <div className='text-center'>
                                        <button type="submit" disabled={isSubmitting} className='btn btn-lg btn-success'>
                                            Reasignar
                                        </button>
                                    </div>

                                </div>
                            </Form>
                        )}


                    </Formik>


                </Box>
            </Modal>
            <Modal
                open={openEstadisticas}
                onClose={handleCloseEstadisticas}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2">
                        Estadísticas
                    </Typography>
                    <br /><br />

                    <LineChart width={1100} height={300} data={data}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="uv" stroke="#8884d8" />
                        <Line type="monotone" dataKey="pv" stroke="#82ca9d" />
                    </LineChart>

                </Box>
            </Modal>
            <Modal
                open={openCredencial}
                onClose={handleCloseCredencial}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CredencialComponent key={props.inspector.id} inspector={props.inspector}></CredencialComponent>
                </Box>
            </Modal>
            {modalEliminarInspector()}
            {modalSubirFirma()}
        </Fragment>
    );
};


export default withRouter(CuadroInspectorComponent)
